import { Level } from 'fitbeat.gym-core';
import i18n from './i18n';

export const skillLevels = [{
  display: i18n.t('home:basic'),
  subtitle: i18n.t('auth:basic'),
  value: Level.Beginner,
}, {
  display: i18n.t('home:intermediate'),
  subtitle: i18n.t('auth:intermediate'),
  value: Level.Basic,
}, {
  display: i18n.t('home:advanced'),
  subtitle: i18n.t('auth:advanced'),
  value: Level.Intermediate,
}];
